import React, { useState } from "react";
import styled from "styled-components";
import DomeHeader from "../components/DomeHeader";
import { Colors } from "../components/styles/Colors";
import { BodyStyles, Header4Styles } from "../components/typography";
import Img from "gatsby-image";
import richText from "../utils/richText";
import Breakpoints from "../components/styles/Breakpoints";
import IngredientsModal from "../components/IngredientsModal";

const Wrapper = styled.section`
  > .gatsby-image-wrapper {
    height: 450px;
  }

  > div:last-child {
    padding: 64px 32px;
    background: ${Colors.sage};
    color: ${Colors.lightBlue};
  }

  @media ${Breakpoints.tablet} {
    display: grid;
    grid-template-columns: 1fr 1fr;
    min-height: 800px;

    > div {
      flex: 0 0 50%;
    }

    > .gatsby-image-wrapper {
      height: 100%;
    }

    > div:last-child {
      padding: 50px;
      box-sizing: border-box;

      > * {
        max-width: 480px;
      }
    }
  }

  @media ${Breakpoints.desktop} {
    > div:last-child {
      padding: 150px;
    }
  }
`;

const SectionText = styled.div`
  li {
    ${BodyStyles}
  }
`;

const AccordionSection = styled.div`
  padding: 32px 0;

  border-bottom: 1px solid ${Colors.hunter};

  &:last-of-type {
    border-bottom: 0;
  }

  > ${SectionText} {
    display: none;
    margin-top: 24px;

    p ~ p {
      margin-top: 15px;
    }
  }

  ${(props) =>
    props.open &&
    `
    ${AccordionHeader} svg {
        transform: rotate(180deg);
    }

    > ${SectionText} {
        display: block;
    }
`}
`;

const AccordionHeader = styled.button`
  ${Header4Styles}

  display: flex;

  justify-content: space-between;
  align-items: center;

  width: 100%;
  height: 32px;

  padding: 0;

  outline: none;

  color: ${Colors.lightBlue};

  background: 0;
  border: 0;
`;

const Chevron = (
  <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6 9l6 6 6-6"
      stroke="#F3F4F5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default function ProductDetails({ product }) {
  const { keyIngredients, ingredients, texture, scent, features, care } = product;

  const [open, setOpen] = useState(ingredients ? "ingredients" : "features");


  function toggleSection(section) {
    return () => {
      setOpen(open === section ? null : section);
    };
  }

  return (
    <Wrapper>
      <Img backgroundColor="#E6E0D8" fluid={product.detailsImage.fluid} />
      <div>
        <DomeHeader text="Product Details" centered light />
        {features &&
          <AccordionSection open={open === "features"}>
            <AccordionHeader onClick={toggleSection("features")}>
              <span>Features</span> {Chevron}
            </AccordionHeader>
            <SectionText>{features.map((feature) => <li>{feature}</li>)}</SectionText>
          </AccordionSection>}
        {care &&
          <AccordionSection open={open === "care"}>
            <AccordionHeader onClick={toggleSection("care")}>
              <span>Care</span> {Chevron}
            </AccordionHeader>
            <SectionText>{care.map((feature) => <li>{feature}</li>)}</SectionText>
          </AccordionSection>}
        {keyIngredients && (
          <AccordionSection open={open === "ingredients"}>
            <AccordionHeader onClick={toggleSection("ingredients")}>
              <span>Key Ingredients</span> {Chevron}
            </AccordionHeader>
            <SectionText>{richText(keyIngredients.raw)}</SectionText>
            <IngredientsModal
              image={product.ingredientsImage.fluid}
              ingredients={product.ingredients}
            />
          </AccordionSection>
        )}
        {texture && (
          <AccordionSection open={open === "texture"}>
            <AccordionHeader onClick={toggleSection("texture")}>
              <span>Texture</span> {Chevron}
            </AccordionHeader>
            <SectionText>{richText(texture.raw)}</SectionText>
          </AccordionSection>
        )}
        {scent && (
          <AccordionSection open={open === "scent"}>
            <AccordionHeader onClick={toggleSection("scent")}>
              <span>Scent</span> {Chevron}
            </AccordionHeader>
            <SectionText>{richText(scent.raw)}</SectionText>
          </AccordionSection>
        )}
      </div>
    </Wrapper>
  );
}
